<template>
  <div class="content" v-if="topic !== null">
    <h1>{{ topic.title }}</h1>
    <div class="cover-section">
      <div class="a-or-b" v-if="topic.ab !== undefined">
        <div class="cell">
          <img class="img" :src="topic.ab.aFileId | blipImageUrl" />
          <div class="desc">
            <div class="title">A: {{ topic.ab.aTitle }}</div>
            <div class="count">{{ topic.ab.aCount }} 표</div>
          </div>
        </div>
        <div class="cell">
          <img class="img" :src="topic.ab.bFileId | blipImageUrl" />
          <div class="desc">
            <div class="title">B: {{ topic.ab.bTitle }}</div>
            <div class="count">{{ topic.ab.bCount }} 표</div>
          </div>
        </div>
      </div>
      <div class="poll" v-if="topic.poll !== undefined">
        <div class="selections">
          <div v-for="(selection, index) in topic.poll.selections" :key="index">
            <h4>{{ `${index + 1}. ${selection.title}(${selection.id}) - ${selection.count}표` }}</h4>
          </div>
        </div>
      </div>
      <div class="tips" v-if="topic.talk !== undefined">
        <div>
          {{ topic.talk.content }}
        </div>
        <div class="row">
          <div class="col-sm-1" v-for="(image, index) in topic.talk.images" :key="index">
            <img :src="image" />
          </div>
        </div>
      </div>
      <div class="tips" v-if="topic.chat !== undefined">
        <div>
          {{ topic.chat.content }}
        </div>
        <div class="row">
          <div class="col-sm-1" v-for="(image, index) in topic.chat.images" :key="index">
            <img :src="image" />
          </div>
        </div>
      </div>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">기본 정보</h4>
      <card class="text-left">
        <div class="row">
          <label class="col-md-2 col-form-label key">ID</label>
          <label class="col-md-3 col-form-label value">{{ topic.id }}</label>
          <base-button class="update-button col-md-2" @click.prevent="goSharePage" type="confirm">공유페이지</base-button>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">작성자</label>
          <div class="col-md-10" v-if="isAdminAuthor">
            <el-select class="select-primary" size="large" placeholder="작성자" v-model="selectedAuthorId">
              <el-option v-for="option in authorOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
            <base-button class="update-button col-6" @click.prevent="onClickUpdateAuthor" type="confirm">업데이트</base-button>
          </div>
          <label class="col-md-10 col-form-label value" v-if="!isAdminAuthor"
            ><a class="pointer" @click="goUserDetail(topic.userId)">{{ `${topic.nickname} (${topic.userId})` }}</a></label
          >
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">참여수</label>
          <span class="col-md-10 col-form-label value">{{ topic.respondentCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">조회수</label>
          <span class="col-md-10 col-form-label value">{{ topic.viewCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">좋아요 수</label>
          <span class="col-md-10 col-form-label value">{{ topic.likeCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">댓글수</label>
          <span class="col-md-10 col-form-label value">{{ topic.commentCount }}</span>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">저장 수</label>
          <span class="col-md-10 col-form-label value">{{ topic.pinCount }}</span>
        </div>

        <div class="member-section">
          <div class="row">
            <label class="col-md-2 col-form-label key">멤버</label>
            <div class="col-md-10">
              <el-select multiple class="select-primary" size="large" placeholder="멤버선택" v-model="selectedMemberIds">
                <el-option v-for="option in memberOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
              </el-select>
              <base-button class="update-button col-6" @click.prevent="onClickUpdateMembers" type="confirm">업데이트</base-button>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="col-md-2 col-form-label key">작성일시</label>
          <div class="col-md-10">
            <base-input class="date-picker" placeholder="작성일시">
              <el-date-picker type="datetime" placeholder="작성일시" v-model="topic.regTime"></el-date-picker>
            </base-input>
            <base-button class="update-button" @click.prevent="onClickUpdateRegTime" type="confirm">업데이트</base-button>
          </div>
        </div>
        <div class="row">
          <label class="col-md-2 col-form-label key">예약 발행 기간</label>
          <div class="col-md-10">
            <base-input class="date-picker" placeholder="">
              <el-date-picker type="datetimerange" start-placeholder="시작일시" end-placeholder="종료일시" v-model="topicPeriod" />
            </base-input>
            <base-button class="update-button" @click.prevent="onClickUpdatePeriod" type="confirm">업데이트</base-button>
          </div>
        </div>

        <div class="tips-metadata text-left" v-if="topic.tips !== undefined">
          <div class="row">
            <label class="col-md-2 col-form-label key">포스트 URL</label>
            <a :href="topic.tips.path" target="_blank" class="col-md-10 col-form-label value">{{ topic.tips.path }}</a>
          </div>
        </div>
      </card>
    </div>
    <div class="row actions">
      <div v-if="topic.state === 1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="onClickDelete" type="success">삭제</base-button>
      </div>
      <div v-if="topic.state === 1" class="col-md-2">
        <base-button class="btn-danger col-md-12" @click="onClickHide" type="success">숨김</base-button>
      </div>
      <div v-if="topic.state !== 1" class="col-md-2">
        <base-button class="footer-buttons col-md-12" @click="onClickShow" type="success">표시</base-button>
      </div>
      <div class="col-md-2">
        <base-button class="footer-buttons col-md-12" @click="onClickRaise" type="success">띄워주기</base-button>
      </div>
      <div class="col-md-2"><base-button class="footer-buttons col-md-12" @click="onClickComments" type="success">댓글 조회</base-button></div>
      <div v-if="topic.state === 1" class="col-md-2">
        <base-button class="footer-buttons col-md-12" @click="sendNotification" type="success">알림 전송</base-button>
      </div>
    </div>
    <div class="pick-section">
      <h4 class="section-title pull-left">띄워주기 내역</h4>
      <card>
        <div class="col-md-12">
          <el-table :data="raises">
            <el-table-column
              v-for="column in hotPickHistoryColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :formatter="column.formatter"
            ></el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="pick-section">
      <h4 class="section-title pull-left">노출 내역</h4>
      <card>
        <div class="col-md-12">
          <el-table :data="hotPickHistory">
            <el-table-column
              v-for="column in hotPickHistoryColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :formatter="column.formatter"
            ></el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="report-section">
      <h4 class="section-title pull-left">신고 내역</h4>
      <card>
        <div class="row">
          <ReportsForContentTableView class="col-12" :reports="reports" />
        </div>
      </card>
    </div>

    <div class="row" v-if="topic.tips !== undefined">
      <base-button class="col-md-12" @click.prevent="onClickModifyTips" type="success">Tips 토픽 수정</base-button>
    </div>

    <TopicRaiseModal :topicId="topic.id" :members="selectedMemberIds" :shouldShow="shouldShowRaiseModal" :onDone="onRaiseDone" :onCancel="onCancelRaiseModal" />
  </div>
</template>

<script>
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { BaseButton, BaseInput, Card } from "@/components/index";
import ReportsForContentTableView from "@/pages/Reports/ReportsForContentTableView";
import { BlipNamespace } from "@/common/BlipNamespace";
import { Alert } from "@/util/Alert";
import { TopicState } from "@/common/TopicState";
import TopicRaiseModal from "@/pages/Topics/TopicRaiseModal";
import * as _ from "lodash";
import { formatDateTime } from "@/util/DateUtils";
import { TopicType } from "@/common/TopicTypes";
import swal from "sweetalert2";
import Endpoints from "@/common/Endpoints";

export default {
  name: "TopicDetail",
  components: {
    TopicRaiseModal,
    BaseButton,
    Card,
    BaseInput,
    ReportsForContentTableView,
  },
  data() {
    return {
      topic: null,
      artistUnit: null,
      isAdminAuthor: false,
      topicPeriod: null,
      reports: [],
      dummyAuthors: [],
      authorOptions: [],
      memberOptions: [],
      selectedAuthorId: null,
      selectedMemberIds: [],
      searchText: null,
      shouldShowRaiseModal: false,
      hotPickHistoryColumns: [
        {
          prop: "typeName",
          label: "구분",
          minWidth: 50,
        },
        {
          label: "시작시간",
          minWidth: 150,
          formatter: (row) => {
            return formatDateTime(row.startTime);
          },
        },
        {
          label: "종료시간",
          minWidth: 150,
          formatter: (row) => (row.endTime === null ? "계속" : formatDateTime(row.endTime)),
        },
        {
          prop: "weight",
          label: "가중치",
          minWidth: 120,
        },
        {
          prop: "adminId",
          label: "운영자",
          minWidth: 120,
          formatter: (row) => (row.adminId ? `${row.adminName}(${row.adminId})` : null),
        },
      ],
      hotPickHistory: [],
      raises: [],
    };
  },
  mounted: async function () {
    await this.getTopic();
  },
  methods: {
    async getTopic() {
      try {
        const topicId = this.$route.params.topicId;
        const result = await this.$axios.get(`/topics/${topicId}`);
        this.topic = result.data.data;

        const roleResult = await this.$axios.get(`/users/${this.topic.userId}/roles`);
        this.isAdminAuthor = _.some(roleResult.data.data, (role) => {
          return role.includes("blipContentAdmin") || role.includes(`dummyUnitFollower/${this.topic.unitId}`);
        });

        if (this.isAdminAuthor) {
          await this.getDummyAuthors(this.topic.unitId);
        }

        await this.getMembers(this.topic.unitId);
        if (this.topic.talk) {
          if (this.topic.talk.imageIds) {
            this.topic.talk.images = [];
            const imageIds = this.topic.talk.imageIds.split(",");
            for (const imageId of imageIds) {
              this.topic.talk.images.push(window.Endpoints.imageServerUrl + imageId);
            }
          }
        }
        if (this.topic.chat) {
          if (this.topic.chat.imageIds) {
            this.topic.chat.images = [];
            const imageIds = this.topic.chat.imageIds.split(",");
            for (const imageId of imageIds) {
              this.topic.chat.images.push(window.Endpoints.imageServerUrl + imageId);
            }
          }
        }
        this.selectedMemberIds = this.topic.artistIds;
        this.topicPeriod = [this.topic.startTime, this.topic.endTime ?? new Date("9999-12-31 23:59:59")];

        await this.getReports();
        await this.getHotPickHistory();
        await this.getRaises();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getMembers(unitId) {
      try {
        const result = await this.$axios.get(`/artistUnit/${unitId}`);
        this.artistUnit = result.data.data;

        this.memberOptions = [{ label: this.artistUnit.blipName, value: this.artistUnit.artistId }];
        this.memberOptions = this.memberOptions.concat(
          this.artistUnit.members.map((member) => ({
            label: member.blipName,
            value: member.artistId,
          }))
        );
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getDummyAuthors(unitId) {
      try {
        const dummyUsers = await this.$axios.get(`/artistUnit/${unitId}/dummyUsers`);
        const contentAdmins = await this.$axios.get(`/artistUnit/${unitId}/contentAdmins`);

        this.dummyAuthors = dummyUsers.data.data.users.concat(contentAdmins.data.data.users);

        this.selectedAuthorId = this.topic.userId;

        this.authorOptions = [
          { label: `${this.topic.nickname}(${this.topic.userId})`, value: this.topic.userId },
          ...this.dummyAuthors
            .filter((author) => author.id !== this.topic.userId)
            .map((author) => ({
              label: `${author.nickname}(${author.id})`,
              value: author.id,
            })),
        ];
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getHotPickHistory() {
      try {
        const res = await this.$axios.get(`/topics/${this.topic.id}/hotPickHistory`);
        this.hotPickHistory = res.data.data.history;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getRaises() {
      try {
        const res = await this.$axios.get(`/topics/${this.topic.id}/raises`);
        this.raises = res.data.data.raises;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getReports() {
      try {
        const result = await this.$axios.get(`/topics/${this.topic.id}/reports`);
        this.reports = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onClickUpdateMembers() {
      try {
        const result = await this.$axios.put(`/topics/${this.topic.id}/artists`, { artistIds: this.selectedMemberIds });
        window.Toast.success(result.data.data.message);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    onClickModifyTips() {
      this.$router.push(`/topic/tipsComposer?topicId=${this.topic.id}`);
    },
    goSharePage() {
      window.open(`${Endpoints.sharePageUrl}/t/${this.topic.idHash}`);
    },
    async onClickHide() {
      if (await Alert.dangerousConfirmCancel("숨김 확인", `${this.topic.title} 토픽을 숨김 처리 하시겠습니까?`)) {
        try {
          await this.$axios.put(`/topics/${this.topic.id}/state`, { state: TopicState.INVISIBLE });
          window.Toast.success("토픽이 숨김 처리 되었습니다.");
          this.$router.back();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickDelete() {
      if (await Alert.dangerousConfirmCancel("삭제 확인", `${this.topic.title} 토픽을 삭제하시겠습니까?`, "삭제", "취소")) {
        try {
          await this.$axios.delete(`/topics/${this.topic.id}`);
          window.Toast.success("토픽이 삭제되었습니다.");
          this.$router.back();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickShow() {
      if (await Alert.dangerousConfirmCancel("표시 확인", `${this.topic.title} 토픽을 표시하시겠습니까?`)) {
        try {
          await this.$axios.put(`/topics/${this.topic.id}/state`, { state: TopicState.VISIBLE });
          window.Toast.success("토픽이 표시 처리 되었습니다.");
          // reload.
          this.$router.go(0);
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickUpdateRegTime() {
      try {
        const result = await this.$axios.put(`/topics/${this.topic.id}/times`, {
          startTime: this.topic.startTime,
          endTime: this.topic.endTime,
          regTime: this.topic.regTime,
        });
        window.Toast.success(result.data.data.message);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onClickUpdatePeriod() {
      try {
        const result = await this.$axios.put(`/topics/${this.topic.id}/times`, {
          startTime: this.topicPeriod[0],
          endTime: this.topicPeriod[1],
          regTime: this.topic.regTime,
        });
        window.Toast.success(result.data.data.message);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onClickUpdateAuthor() {
      try {
        const result = await this.$axios.put(`/topics/${this.topic.id}/author`, {
          userId: this.selectedAuthorId,
        });
        window.Toast.success(result.data.data.message);
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    onClickRaise() {
      this.shouldShowRaiseModal = true;
    },
    async onRaiseDone() {
      await this.getRaises();
      this.onCancelRaiseModal();
    },
    async sendNotification() {
      swal
        .fire({
          title: "알림",
          text: `${this.topic.title} 알림을 전송 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "알림",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios.put(`/topics/${this.topic.id}/notification`).then((res) => {
                Toast.success("토픽 알림이 전송되었습니다");
              });
            } catch (err) {
              Toast.error("토픽 알림 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    onClickComments() {
      this.$router.push(`/comment/all?namespace=${BlipNamespace.TOPIC}&unitId=${this.topic.unitId}&contentId=${this.topic.id}`);
    },
    onCancelRaiseModal() {
      this.shouldShowRaiseModal = false;
    },
    goUserDetail(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
  watch: {
    selectedMemberIds: function (newValue, oldValue) {
      if (!this.artistUnit) {
        return;
      }

      const unitArtistId = this.artistUnit.artistId;
      if (newValue?.includes(unitArtistId) && !oldValue?.includes(unitArtistId)) {
        this.selectedMemberIds = [unitArtistId];
      } else if (oldValue?.includes(unitArtistId) && newValue?.length > 1) {
        this.selectedMemberIds = newValue.filter((item) => item !== unitArtistId);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  text-align: unset;
}

.cover-section {
  .a-or-b {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .cell {
      width: 50%;
      img {
        max-width: 50%;
        min-height: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
  }

  .tips {
    img {
      margin-bottom: 30px;
    }
  }
}

.section-title {
  text-decoration: underline;
}

.key {
  font-weight: bold;
}

.actions {
  margin-bottom: 40px;
}

.update-button {
  margin-left: 10px;
  padding-left: 5px;
  padding-right: 5px;
  width: 80px;
}

.date-picker {
  display: inline-block;
}
.pointer {
  cursor: pointer;
}
</style>
